(function () {
  function init() {
    var root = document.querySelector('[data-btsm-public-lessons]');
    if (!root) return;

    var pageHandle = root.getAttribute('data-page-handle') || '';
    var pageType = getPublicLessonsPageType(pageHandle);
    var crmBase = (root.getAttribute('data-crm-base') || '').replace(/\/$/, '');
    var storeBase = (root.getAttribute('data-store-base') || '').replace(/\/$/, '');
    var supportEmail = root.getAttribute('data-support-email') || 'beachtenissantamonica@gmail.com';
    var query = new URLSearchParams(window.location.search);
    var selectedSessionId = query.get('selected_session') || query.get('session_id') || '';

    root.className = 'btsm-public-lessons';
    root.innerHTML = '<div class="btsm-public-lessons__loading">Loading live lesson availability...</div>';

    if (pageType === 'classes') {
      loadClassesPage(root, crmBase, storeBase, supportEmail);
      return;
    }

    if (pageType === 'beginner') {
      loadBeginnerBookingPage(root, crmBase, supportEmail, selectedSessionId, query, pageHandle);
      return;
    }

    if (pageType === 'trial') {
      loadTrialBookingPage(root, crmBase, supportEmail, selectedSessionId, pageHandle);
    }
  }

  async function loadClassesPage(root, crmBase, storeBase, supportEmail) {
    try {
      var data = await fetchJson(crmBase + '/api/public/scheduling/classes');
      var locations = data.locations || [];
      var beginner = data.groups && data.groups.beginner ? data.groups.beginner : [];
      var intermediate = data.groups && data.groups.intermediate ? data.groups.intermediate : [];
      var activeLocationId = '';

      function render() {
        var filteredBeginner = filterByLocation(beginner, activeLocationId);
        var filteredIntermediate = filterByLocation(intermediate, activeLocationId);

        root.innerHTML = [
          renderHero('Public Lessons', 'Find the next beach tennis lesson that still has room, pick your spot, and head straight into booking.', [
            beginner.length ? '<span class="btsm-public-lessons__pill">Beginner lessons available</span>' : '',
            intermediate.length ? '<span class="btsm-public-lessons__pill">Intermediate lessons available</span>' : '',
            '<span class="btsm-public-lessons__pill">Up to 30 days ahead</span>'
          ].join('')),
          renderLocationFilters(locations, activeLocationId),
          beginner.length || intermediate.length
            ? [
                renderLessonSection('Beginner', 'Start with the sessions that best fit new and developing players.', filteredBeginner, function (session) {
                  return storeBase + '/pages/book-intro-lesson?selected_session=' + encodeURIComponent(session.id);
                }),
                filteredIntermediate.length
                  ? renderLessonSection('Intermediate', 'Shown only when Level D public lessons have live availability.', filteredIntermediate, function (session) {
                    return storeBase + '/pages/book-intro-lesson?selected_session=' + encodeURIComponent(session.id);
                  })
                  : ''
              ].join('')
            : renderEmptyState('No paid public lessons are available right now.', supportEmail)
        ].join('');

        attachLocationFilterHandlers(root, function (locationId) {
          activeLocationId = locationId;
          render();
        });
      }

      render();
    } catch (error) {
      root.innerHTML = renderError(error.message || 'Could not load classes.', supportEmail);
    }
  }

  async function loadBeginnerBookingPage(root, crmBase, supportEmail, selectedSessionId, query, pageHandle) {
    try {
      var data = await fetchJson(crmBase + '/api/public/scheduling/classes' + buildSessionQuery(selectedSessionId));
      var groups = data.groups || {};
      var sessions = []
        .concat(groups.beginner || [])
        .concat(groups.intermediate || []);
      var locations = data.locations || [];
      var selectedGroup = pickInitialGroup(selectedSessionId, data.selected_session, groups);
      var activeLocationId = '';
      var statusBanner = query.get('checkout') === 'success'
        ? renderSuccess('Payment received. We are confirming your lesson now. If you need to change it later, email ' + supportEmail + '.')
        : query.get('checkout') === 'cancelled'
          ? renderNotice('Checkout was cancelled. Your class was not booked. Pick another available time whenever you are ready.')
          : '';
      var checkoutSessionId = query.get('checkout_session_id') || '';

      function getVisibleSessions() {
        var list = groups[selectedGroup] || [];
        return filterByLocation(list, activeLocationId);
      }

      function ensureSelection() {
        var visible = getVisibleSessions();
        if (!visible.length) return null;
        if (!selectedSessionId || !visible.some(function (session) { return session.id === selectedSessionId; })) {
          selectedSessionId = visible[0].id;
        }
        return visible.find(function (session) { return session.id === selectedSessionId; }) || visible[0];
      }

      function render() {
        var visibleSessions = getVisibleSessions();
        var selectedSession = ensureSelection();

        if (query.get('checkout') === 'success' && checkoutSessionId) {
          var storedPaidLesson = loadStoredPaidLessonTrackingPayload(checkoutSessionId);
          var paidLessonPayload = storedPaidLesson || (selectedSession
            ? buildPaidLessonTrackingPayload(selectedSession, {
                checkout_session_id: checkoutSessionId,
                source_page: pageHandle
              })
            : null);

          if (paidLessonPayload) {
            trackLessonConversion('btsm_paid_lesson_purchase', paidLessonPayload);
          }
        }

        root.innerHTML = [
          renderHero('Book Your Lesson', 'Pick the lesson that works best, enter your info, and head into secure checkout. Cancellations and reschedules are handled by email.', [
            '<span class="btsm-public-lessons__pill">Selection</span>',
            '<span class="btsm-public-lessons__pill">Info form</span>',
            '<span class="btsm-public-lessons__pill">Stripe checkout</span>'
          ].join('')),
          statusBanner,
          renderGroupFilters(groups, selectedGroup),
          renderLocationFilters(locations, activeLocationId),
          visibleSessions.length
            ? [
                '<div class="btsm-public-lessons__shell">',
                '<div class="btsm-public-lessons__panel">',
                '<div class="btsm-public-lessons__section-header"><div><h2 class="btsm-public-lessons__section-title">Choose your class</h2><p class="btsm-public-lessons__section-copy">Only classes with live availability are shown here.</p></div></div>',
                renderBookingSessionOptions(visibleSessions, selectedSessionId),
                '</div>',
                '<div class="btsm-public-lessons__panel">',
                selectedSession ? renderCheckoutSidebar(selectedSession, supportEmail) : renderEmptyState('Pick a class to continue.', supportEmail),
                '</div>',
                '</div>'
              ].join('')
            : renderEmptyState('No classes match the current filters.', supportEmail)
        ].join('');

        attachLocationFilterHandlers(root, function (locationId) {
          activeLocationId = locationId;
          render();
        });

        attachGroupFilterHandlers(root, function (group) {
          selectedGroup = group;
          render();
        });

        attachSessionOptionHandlers(root, function (sessionId) {
          selectedSessionId = sessionId;
          render();
        });

        attachPaidBookingForm(root, crmBase, selectedSessionId, pageHandle);
      }

      render();
    } catch (error) {
      root.innerHTML = renderError(error.message || 'Could not load booking page.', supportEmail);
    }
  }

  async function loadTrialBookingPage(root, crmBase, supportEmail, selectedSessionId, pageHandle) {
    try {
      var data = await fetchJson(crmBase + '/api/public/scheduling/trials' + buildSessionQuery(selectedSessionId));
      var sessions = data.sessions || [];
      var locations = data.locations || [];
      var activeLocationId = '';
      var successState = null;

      function getVisibleSessions() {
        return filterByLocation(sessions, activeLocationId);
      }

      function ensureSelection() {
        var visible = getVisibleSessions();
        if (!visible.length) return null;
        if (!selectedSessionId || !visible.some(function (session) { return session.id === selectedSessionId; })) {
          selectedSessionId = visible[0].id;
        }
        return visible.find(function (session) { return session.id === selectedSessionId; }) || visible[0];
      }

      function render() {
        var visibleSessions = getVisibleSessions();
        var selectedSession = ensureSelection();

        root.innerHTML = [
          renderHero('Book A Free Trial', 'Choose the trial session that works best, tell us where to reach you, and we will save your spot.', [
            '<span class="btsm-public-lessons__pill">One lifetime trial</span>',
            '<span class="btsm-public-lessons__pill">All times live from CRM</span>'
          ].join('')),
          successState ? renderSuccess(successState) : '',
          renderLocationFilters(locations, activeLocationId),
          visibleSessions.length
            ? [
                '<div class="btsm-public-lessons__shell">',
                '<div class="btsm-public-lessons__panel">',
                '<div class="btsm-public-lessons__section-header"><div><h2 class="btsm-public-lessons__section-title">Choose your trial</h2><p class="btsm-public-lessons__section-copy">Each session below still has room right now.</p></div></div>',
                renderBookingSessionOptions(visibleSessions, selectedSessionId),
                '</div>',
                '<div class="btsm-public-lessons__panel">',
                selectedSession ? renderTrialSidebar(selectedSession, supportEmail) : renderEmptyState('Pick a trial lesson to continue.', supportEmail),
                '</div>',
                '</div>'
              ].join('')
            : renderEmptyState('No trial lessons are available right now.', supportEmail)
        ].join('');

        attachLocationFilterHandlers(root, function (locationId) {
          activeLocationId = locationId;
          render();
        });

        attachSessionOptionHandlers(root, function (sessionId) {
          selectedSessionId = sessionId;
          render();
        });

        attachTrialBookingForm(root, crmBase, selectedSessionId, pageHandle, function (message) {
          successState = message;
          render();
          window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
        });
      }

      render();
    } catch (error) {
      root.innerHTML = renderError(error.message || 'Could not load trial lessons.', supportEmail);
    }
  }

  function renderHero(eyebrow, title, leadPills) {
    return [
      '<section class="btsm-public-lessons__hero">',
      '<p class="btsm-public-lessons__eyebrow">' + escapeHtml(eyebrow) + '</p>',
      '<h1 class="btsm-public-lessons__title">' + (eyebrow === 'Public Lessons' ? 'Live beach tennis classes' : escapeHtml(eyebrow)) + '</h1>',
      '<p class="btsm-public-lessons__lead">' + escapeHtml(title) + '</p>',
      leadPills ? '<div class="btsm-public-lessons__meta">' + leadPills + '</div>' : '',
      '</section>'
    ].join('');
  }

  function renderLessonSection(title, copy, sessions, buildUrl) {
    if (!sessions.length) return '';
    return [
      '<section class="btsm-public-lessons__section">',
      '<div class="btsm-public-lessons__section-header"><div><h2 class="btsm-public-lessons__section-title">' + escapeHtml(title) + '</h2><p class="btsm-public-lessons__section-copy">' + escapeHtml(copy) + '</p></div></div>',
      '<div class="btsm-public-lessons__grid">',
      sessions.map(function (session) { return renderClassCard(session, buildUrl(session)); }).join(''),
      '</div>',
      '</section>'
    ].join('');
  }

  function renderClassCard(session, href) {
    return [
      '<article class="btsm-public-lessons__card">',
      '<div class="btsm-public-lessons__card-head"><div><p class="btsm-public-lessons__card-title">' + escapeHtml(session.location.name) + '</p><p class="btsm-public-lessons__small">' + escapeHtml(session.lesson_label) + '</p></div><span class="btsm-public-lessons__badge">' + escapeHtml(session.price_label || (session.public_spots_remaining + ' spots left')) + '</span></div>',
      '<div class="btsm-public-lessons__list">',
      renderInfoRow(session.weekday_label + ', ' + session.date_label, session.time_label),
      renderInfoRow('Coach', session.coach_name || 'Coach assignment coming soon'),
      renderInfoRow('Location', session.location.address || session.location.city || session.location.name),
      '</div>',
      '<div class="btsm-public-lessons__footer"><span class="btsm-public-lessons__small">' + escapeHtml(session.public_spots_remaining + ' public spots left') + '</span><div class="btsm-public-lessons__actions">' +
        (session.location.directions_url ? '<a class="btsm-public-lessons__button-secondary" href="' + escapeAttribute(session.location.directions_url) + '" target="_blank" rel="noopener">Directions</a>' : '') +
        '<a class="btsm-public-lessons__button" href="' + escapeAttribute(href) + '">Book</a></div></div>',
      '</article>'
    ].join('');
  }

  function renderBookingSessionOptions(sessions, selectedSessionId) {
    return sessions.map(function (session) {
      var checked = session.id === selectedSessionId;
      return [
        '<label class="btsm-public-lessons__session-option' + (checked ? ' is-selected' : '') + '" data-session-option data-session-id="' + escapeAttribute(session.id) + '">',
        '<input type="radio" name="lesson-session" value="' + escapeAttribute(session.id) + '"' + (checked ? ' checked' : '') + '>',
        '<div class="btsm-public-lessons__option-top">',
        '<div><strong>' + escapeHtml(session.weekday_label + ', ' + session.date_label) + '</strong><span>' + escapeHtml(session.time_label + ' • ' + session.location.name) + '</span></div>',
        '<span class="btsm-public-lessons__badge">' + escapeHtml(session.price_label || (session.public_spots_remaining + ' spots left')) + '</span>',
        '</div>',
        '<p class="btsm-public-lessons__small">' + escapeHtml((session.coach_name || 'Coach assignment coming soon') + ' • ' + (session.location.address || session.location.city || 'Beach location')) + '</p>',
        '</label>'
      ].join('');
    }).join('');
  }

  function renderCheckoutSidebar(session, supportEmail) {
    return [
      '<h2 class="btsm-public-lessons__section-title">Your selection</h2>',
      '<p class="btsm-public-lessons__section-copy">' + escapeHtml(session.lesson_label + ' lesson at ' + session.location.name) + '</p>',
      '<div class="btsm-public-lessons__notice"><strong>' + escapeHtml(session.date_label) + '</strong><br>' + escapeHtml(session.time_label + ' • ' + session.public_spots_remaining + ' public spots left') + '</div>',
      session.location.directions_url ? '<p class="btsm-public-lessons__support"><a class="btsm-public-lessons__link" href="' + escapeAttribute(session.location.directions_url) + '" target="_blank" rel="noopener">Open directions for ' + escapeHtml(session.location.name) + '</a></p>' : '',
      '<form class="btsm-public-lessons__form" data-paid-booking-form>',
      renderField('Name', 'name', 'Your full name'),
      renderField('Email', 'email', 'you@example.com', 'email'),
      renderField('Phone', 'phone', '(310) 555-1234', 'tel'),
      '<button class="btsm-public-lessons__button" type="submit">Continue to secure checkout</button>',
      '<div class="btsm-public-lessons__error" data-form-error hidden></div>',
      '</form>',
      '<p class="btsm-public-lessons__support">Need to cancel or reschedule later? Email <a class="btsm-public-lessons__link" href="mailto:' + escapeAttribute(supportEmail) + '">' + escapeHtml(supportEmail) + '</a>.</p>'
    ].join('');
  }

  function renderTrialSidebar(session, supportEmail) {
    return [
      '<h2 class="btsm-public-lessons__section-title">Reserve your free trial</h2>',
      '<p class="btsm-public-lessons__section-copy">' + escapeHtml(session.location.name + ' • ' + session.date_label + ' • ' + session.time_label) + '</p>',
      '<div class="btsm-public-lessons__notice"><strong>One lifetime trial per email or phone number.</strong><br>We handle any later changes by email.</div>',
      session.location.directions_url ? '<p class="btsm-public-lessons__support"><a class="btsm-public-lessons__link" href="' + escapeAttribute(session.location.directions_url) + '" target="_blank" rel="noopener">Open directions for ' + escapeHtml(session.location.name) + '</a></p>' : '',
      '<form class="btsm-public-lessons__form" data-trial-booking-form>',
      renderField('Name', 'name', 'Your full name'),
      renderField('Email', 'email', 'you@example.com', 'email'),
      renderField('Phone', 'phone', '(310) 555-1234', 'tel'),
      '<button class="btsm-public-lessons__button" type="submit">Book my free trial</button>',
      '<div class="btsm-public-lessons__error" data-form-error hidden></div>',
      '</form>',
      '<p class="btsm-public-lessons__support">Questions or changes? Email <a class="btsm-public-lessons__link" href="mailto:' + escapeAttribute(supportEmail) + '">' + escapeHtml(supportEmail) + '</a>.</p>'
    ].join('');
  }

  function renderField(label, name, placeholder, type) {
    return [
      '<div class="btsm-public-lessons__field">',
      '<label for="btsm-' + escapeAttribute(name) + '">' + escapeHtml(label) + '</label>',
      '<input id="btsm-' + escapeAttribute(name) + '" name="' + escapeAttribute(name) + '" type="' + escapeAttribute(type || 'text') + '" placeholder="' + escapeAttribute(placeholder) + '" required>',
      '</div>'
    ].join('');
  }

  function renderLocationFilters(locations, activeLocationId) {
    if (!locations.length) return '';
    return [
      '<div class="btsm-public-lessons__filters" data-location-filters>',
      '<button class="btsm-public-lessons__filter-button' + (!activeLocationId ? ' is-active' : '') + '" type="button" data-location-filter="">All locations</button>',
      locations.map(function (location) {
        var isActive = location.id === activeLocationId;
        return '<button class="btsm-public-lessons__filter-button' + (isActive ? ' is-active' : '') + '" type="button" data-location-filter="' + escapeAttribute(location.id) + '">' + escapeHtml(location.name) + '</button>';
      }).join(''),
      '</div>'
    ].join('');
  }

  function renderGroupFilters(groups, activeGroup) {
    var buttons = [];
    if (groups.beginner && groups.beginner.length) {
      buttons.push('<button class="btsm-public-lessons__filter-button' + (activeGroup === 'beginner' ? ' is-active' : '') + '" type="button" data-group-filter="beginner">Beginner</button>');
    }
    if (groups.intermediate && groups.intermediate.length) {
      buttons.push('<button class="btsm-public-lessons__filter-button' + (activeGroup === 'intermediate' ? ' is-active' : '') + '" type="button" data-group-filter="intermediate">Intermediate</button>');
    }

    return buttons.length
      ? '<div class="btsm-public-lessons__filters" data-group-filters>' + buttons.join('') + '</div>'
      : '';
  }

  function renderInfoRow(title, value) {
    return '<div class="btsm-public-lessons__row"><div><strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(value) + '</span></div></div>';
  }

  function renderEmptyState(message, supportEmail) {
    return '<div class="btsm-public-lessons__empty">' + escapeHtml(message) + '<p class="btsm-public-lessons__support">Need help finding the right class? Email <a class="btsm-public-lessons__link" href="mailto:' + escapeAttribute(supportEmail) + '">' + escapeHtml(supportEmail) + '</a>.</p></div>';
  }

  function renderError(message, supportEmail) {
    return '<div class="btsm-public-lessons__error">' + escapeHtml(message) + '<p class="btsm-public-lessons__support">If this keeps happening, email <a class="btsm-public-lessons__link" href="mailto:' + escapeAttribute(supportEmail) + '">' + escapeHtml(supportEmail) + '</a>.</p></div>';
  }

  function renderNotice(message) {
    return '<div class="btsm-public-lessons__notice">' + escapeHtml(message) + '</div>';
  }

  function renderSuccess(message) {
    return '<div class="btsm-public-lessons__success">' + escapeHtml(message) + '</div>';
  }

  function attachLocationFilterHandlers(root, onSelect) {
    root.querySelectorAll('[data-location-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        onSelect(button.getAttribute('data-location-filter') || '');
      });
    });
  }

  function attachGroupFilterHandlers(root, onSelect) {
    root.querySelectorAll('[data-group-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        onSelect(button.getAttribute('data-group-filter') || 'beginner');
      });
    });
  }

  function attachSessionOptionHandlers(root, onSelect) {
    root.querySelectorAll('[data-session-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        onSelect(option.getAttribute('data-session-id') || '');
      });
    });
  }

  function attachPaidBookingForm(root, crmBase, selectedSessionId, pageHandle) {
    var form = root.querySelector('[data-paid-booking-form]');
    if (!form) return;
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var errorBox = form.querySelector('[data-form-error]');
      hideError(errorBox);

      var payload = {
        session_id: selectedSessionId,
        name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim(),
        phone: form.elements.phone.value.trim(),
        source_page: pageHandle
      };

      try {
        setSubmitting(form, true, 'Redirecting to checkout...');
        var data = await fetchJson(crmBase + '/api/public/scheduling/dropin-checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        storePaidLessonTrackingPayload(data.checkout_session_id, buildPaidLessonTrackingPayload(data.lesson, {
          checkout_session_id: data.checkout_session_id,
          source_page: pageHandle
        }));
        window.location.href = data.checkout_url;
      } catch (error) {
        showError(errorBox, error.message || 'Could not start checkout.');
        setSubmitting(form, false, 'Continue to secure checkout');
      }
    });
  }

  function attachTrialBookingForm(root, crmBase, selectedSessionId, pageHandle, onSuccess) {
    var form = root.querySelector('[data-trial-booking-form]');
    if (!form) return;
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var errorBox = form.querySelector('[data-form-error]');
      hideError(errorBox);

      var payload = {
        session_id: selectedSessionId,
        name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim(),
        phone: form.elements.phone.value.trim(),
        source_page: pageHandle
      };

      try {
        setSubmitting(form, true, 'Saving your trial...');
        var data = await fetchJson(crmBase + '/api/public/scheduling/trial-bookings', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        trackLessonConversion('btsm_trial_booking_confirmed', buildTrialTrackingPayload(data.lesson, {
          lead_id: data.leadId || '',
          source_page: pageHandle
        }));
        onSuccess('Your free trial is booked for ' + data.lesson.weekday_label + ', ' + data.lesson.date_label + ' at ' + data.lesson.time_label + ' in ' + data.lesson.location.name + '.');
      } catch (error) {
        showError(errorBox, error.message || 'Could not book trial.');
        setSubmitting(form, false, 'Book my free trial');
      }
    });
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options);
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.error || 'Request failed');
    }
    return data;
  }

  function setSubmitting(form, isSubmitting, label) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;
    button.disabled = isSubmitting;
    button.textContent = label;
  }

  function showError(errorBox, message) {
    if (!errorBox) return;
    errorBox.hidden = false;
    errorBox.textContent = message;
  }

  function hideError(errorBox) {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  }

  function filterByLocation(sessions, locationId) {
    if (!locationId) return sessions;
    return sessions.filter(function (session) { return session.location && session.location.id === locationId; });
  }

  function pickInitialGroup(selectedSessionId, selectedSession, groups) {
    if (selectedSessionId && selectedSession && selectedSession.lesson_group) {
      return selectedSession.lesson_group;
    }
    if (groups.beginner && groups.beginner.length) return 'beginner';
    return 'intermediate';
  }

  function buildSessionQuery(selectedSessionId) {
    return selectedSessionId ? ('?session_id=' + encodeURIComponent(selectedSessionId)) : '';
  }

  function getPublicLessonsPageType(pageHandle) {
    if (pageHandle === 'classes') return 'classes';
    if (pageHandle === 'book-beginner' || pageHandle === 'book-intro-lesson' || pageHandle === 'book-intro-lesson-test') return 'beginner';
    if (pageHandle === 'book-trial' || pageHandle === 'free-trial-lesson' || pageHandle === 'free-trial-lesson-test') return 'trial';
    return '';
  }

  function storePaidLessonTrackingPayload(checkoutSessionId, payload) {
    if (!checkoutSessionId || !payload) return;
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(getPaidLessonTrackingStorageKey(checkoutSessionId), JSON.stringify(payload));
      }
    } catch (error) {
      // Ignore storage failures so checkout can continue.
    }
  }

  function loadStoredPaidLessonTrackingPayload(checkoutSessionId) {
    if (!checkoutSessionId) return null;
    try {
      if (!window.sessionStorage) return null;
      var raw = window.sessionStorage.getItem(getPaidLessonTrackingStorageKey(checkoutSessionId));
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function getPaidLessonTrackingStorageKey(checkoutSessionId) {
    return 'btsm-paid-lesson:' + checkoutSessionId;
  }

  function trackLessonConversion(eventName, payload) {
    if (!eventName || !payload || !payload.event_id) return;
    if (hasTrackedLessonConversion(eventName, payload.event_id)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
    markLessonConversionTracked(eventName, payload.event_id);
  }

  function hasTrackedLessonConversion(eventName, eventId) {
    try {
      return window.sessionStorage && window.sessionStorage.getItem(getLessonConversionStorageKey(eventName, eventId)) === '1';
    } catch (error) {
      return false;
    }
  }

  function markLessonConversionTracked(eventName, eventId) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(getLessonConversionStorageKey(eventName, eventId), '1');
      }
    } catch (error) {
      // Ignore storage failures so tracking does not block booking flows.
    }
  }

  function getLessonConversionStorageKey(eventName, eventId) {
    return 'btsm-conversion:' + eventName + ':' + eventId;
  }

  function buildPaidLessonTrackingPayload(session, extras) {
    var price = typeof session.price === 'number' ? session.price : 0;
    var lessonLabel = session.lesson_label || 'Beginner';
    var lessonGroup = session.lesson_group || 'beginner';
    var locationName = session.location && session.location.name ? session.location.name : '';
    var checkoutSessionId = extras && extras.checkout_session_id ? extras.checkout_session_id : '';
    var eventId = checkoutSessionId ? ('paid-' + checkoutSessionId) : ('paid-' + session.id);

    return {
      event_id: eventId,
      conversion_type: 'paid_public_lesson',
      source_page: extras && extras.source_page ? extras.source_page : 'book-beginner',
      lesson_group: lessonGroup,
      lesson_label: lessonLabel,
      location_id: session.location && session.location.id ? session.location.id : '',
      location_name: locationName,
      session_id: session.id,
      session_start: session.iso_start || '',
      session_date: session.date_label || '',
      session_weekday: session.weekday_label || '',
      session_time: session.time_label || '',
      checkout_session_id: checkoutSessionId,
      value: price,
      currency: 'USD',
      content_name: lessonLabel + ' Lesson',
      content_category: 'public_lesson',
      ecommerce: {
        currency: 'USD',
        value: price,
        items: [{
          item_id: session.id,
          item_name: lessonLabel + ' Lesson',
          item_category: 'public_lesson',
          item_category2: lessonGroup,
          item_variant: locationName,
          price: price,
          quantity: 1
        }]
      }
    };
  }

  function buildTrialTrackingPayload(session, extras) {
    var lessonLabel = session.lesson_label || 'Trial';
    var locationName = session.location && session.location.name ? session.location.name : '';
    var leadId = extras && extras.lead_id ? extras.lead_id : '';
    var eventId = leadId ? ('trial-' + leadId) : ('trial-' + session.id);

    return {
      event_id: eventId,
      conversion_type: 'trial_lesson',
      source_page: extras && extras.source_page ? extras.source_page : 'book-trial',
      lesson_group: 'trial',
      lesson_label: lessonLabel,
      location_id: session.location && session.location.id ? session.location.id : '',
      location_name: locationName,
      session_id: session.id,
      session_start: session.iso_start || '',
      session_date: session.date_label || '',
      session_weekday: session.weekday_label || '',
      session_time: session.time_label || '',
      lead_id: leadId,
      value: 0,
      currency: 'USD',
      content_name: 'Free Trial Lesson',
      content_category: 'trial_lesson'
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
